import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import './bin-readings';
import './export-bin-button';

class BinData extends LitEntity {
  static get properties() {
    return {
      start: { type: String, attribute: false },
      end: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    `];
  }

  render() {
    return html`
      <div class="header">
        <h2>Readings</h2>
        <export-bin-button .href="${this.href}" .start="${this.start}" .end="${this.end}"></export-bin-button>
      </div>
      <bin-readings .href="${this.href}" @update="${this._onBinReadingsUpdate}"></bin-readings>
    `;
  }

  _onBinReadingsUpdate(event) {
    const { start, end } = event?.details?.entity?.properties || {};
    if (!start || !end) {
      return;
    }
    this.start = start;
    this.end = end;
  }
}

window.customElements.define('bin-data', BinData);
